import { gql } from '@apollo/client';

import { LectureSingleFragment } from '../fragments';

export const UpdateLectureMutation = gql`
    mutation updateOLLecture($id: ID!, $item: OLLectureArgs!) {
        updateOLLecture(id: $id, item: $item) {
            ...LectureSingle
        }
    }
    ${LectureSingleFragment}
`;
